import FooterLogo from "./FooterLogo";
import FooterCompany from "./FooterCompany";
import FooterPolicy from "./FooterPolicy";
import FooterSocial from "./FooterSocial";
import FooterCopyright from "./FooterCopyright";
import FooterSupport from "./FooterSupport";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-top">
                <div className="row flex">
                    <div className="column width-3">
                        <FooterLogo />
                    </div>
                    <div className="column width-9">
                        <div className="row two-columns-on-tablet">
                            <div className="column width-3">
                                <FooterCompany />
                            </div>
                            <div className="column width-3">
                                <FooterPolicy />
                            </div>
                            <div className="column width-3">
                                <FooterSupport />
                            </div>
                            <div className="column width-3">
                                <FooterSocial />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <FooterCopyright />
        </footer>
    )
}

export default Footer;